/* eslint-disable no-prototype-builtins */
import { EmbeddedRecordsMixin } from '@warp-drive/legacy/serializer/rest';
import FinanceSerializer from './base';

export default class Account extends FinanceSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    caregiverIds: { serialize: 'ids' },
  };

  normalize(modelClass, payload) {
    let balance = payload.balance || 0;
    payload.balance = (balance / 100).toFixed(2);
    if (!payload.hasOwnProperty('caregiverIds')) {
      // Work around Go's "omitempty" on caregiverIds.  Otherwise, the last
      // caregiverId persists until a refresh (or a different caregiver is
      // added to the list, so that we get a list in the response).
      payload.caregiverIds = [];
    }
    return super.normalize(...arguments);
  }

  serialize() {
    let hash = super.serialize(...arguments);
    hash.balance = Math.round(hash.balance * 100);
    return hash;
  }
}
